<template>
  <div class="this-page" id="position">
    <div class="content" v-if="netError">
      <p style="color: red">网络请求超时，请刷新页面重试</p>
    </div>
    <el-alert
      v-if="anyLoading"
      class="wait-alert"
      type="error"
      :closable="false"
      show-icon
      title="等待模式处理中：已扣费，素材正在后台生成下载链接"
      description="通常需 20 秒 - 2 分钟，完成后会自动出现下载按钮，无需刷新页面；若下载失败，费用将自动退回，请重新尝试或联系上方微信客服。请耐心等待，不要关闭页面。"
      style="margin-bottom: 15px"
    >
    </el-alert>
    <el-table
      :data="tableData"
      class="table"
      id="position"
      v-if="!downloadStarted"
    >
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="照片信息">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.img" alt /> -->
          <el-image
            v-show="
              scope.row.webType !== 'shutterstock_V2' &&
              scope.row.webType !== 'music' &&
              scope.row.webType !== 'shutterstock_V3'
            "
            style="
              margin-right: 10px;
              float: left;
              width: 60px;
              height: 60px;
              border-radius: 4px;
              cursor: pointer;
            "
            :src="scope.row.img"
            @click="handleImgPreview(scope.row)"
          >
            <div slot="error" class="image-slot">
              <img
                :src="scope.row.errorIcon"
                @click="handleImgPreview(scope.row)"
                alt
              />
            </div>
          </el-image>
          <div class="fr">
            <p class="code">{{ scope.row.id }}</p>
            <p class="label" v-if="scope.row.webType == 'music'">
              音乐名:{{ scope.row.title }} &nbsp; 作者:{{ scope.row.videoSize }}
            </p>
            <p class="label" v-else>
              {{ scope.row.imgType }}
              <span class="size">{{ scope.row.imgSize }}</span>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下载费用">
        <template slot-scope="scope">
          <div class="price" v-if="scope.row.complete">
            <p class="font-red">余额：{{ scope.row.price }}元</p>
          </div>
          <div class="price" v-else>
            <p
              class="font-blue"
              v-if="scope.row.type && !scope.row.isBuy && !scope.row.isChange"
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
              <br />
              <span v-show="scope.row.isOffset" class="font-red"
                >（此图为高级图，请确认费用后联系客服下载）</span
              >
            </p>
            <p
              class="font-blue"
              v-else-if="
                scope.row.type && !scope.row.isBuy1 && scope.row.isChange
              "
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
            </p>
            <p class="font-blue" v-else>{{ scope.row.msg }}</p>
            <el-button
              type="danger"
              round
              v-if="scope.row.saleType !== null && scope.row.saleType !== ''"
              size="mini"
              >{{ scope.row.saleType }}</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图片格式">
        <template slot-scope="scope" v-if="scope.row.showType">
          <div v-if="!scope.row.isVideo">
            <el-select
              v-model="scope.row.value"
              v-if="scope.row.type"
              :disabled="scope.row.disabled"
              placeholder="请选择"
            >
              <el-option
                v-for="item in scope.row.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- {{scope.row.options[0].label}} -->
          </div>
          <div v-else-if="scope.row.webType == 'vadobestock'">
            <span class="font-red">HD/4K(官网最大像素)</span>
          </div>
          <div v-else-if="scope.row.webType == 'music'">
            <span class="font-red">所有版本</span>
          </div>
          <div v-else>
            <el-radio-group
              v-model="scope.row.videoLabel"
              v-if="scope.row.type"
              :disabled="scope.row.videoDisabled"
            >
              <el-radio
                v-for="item in scope.row.videoOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @change="
                  changePrice(scope.$index, tableData, item.label, item.value)
                "
              ></el-radio>
            </el-radio-group>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作状态">
        <template slot-scope="scope">
          <div class="processBar" v-if="scope.row.loading"></div>
          <div v-else-if="!scope.row.loading && scope.row.complete">
            <div v-if="scope.row.webType !== 'music'">
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button
                  type="primary"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >点击下载</el-button
                ></a
              >
              <a rel="nofollow" :href="scope.row.downurl2" target="_blank"
                ><el-button
                  type="success"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >备用下载</el-button
                ></a
              >
              <a rel="nofollow" :href="scope.row.downurl3" target="_blank"
                ><el-button
                  type="danger"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >海外下载</el-button
                ></a
              >
            </div>
            <div v-else>
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button
                  type="primary"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >全曲版本</el-button
                ></a
              >
              <a rel="nofollow" :href="scope.row.downurl2" target="_blank"
                ><el-button
                  type="success"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >海外下载</el-button
                ></a
              >
              <a rel="nofollow" :href="scope.row.downurl3" target="_blank"
                ><el-button
                  type="danger"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >分段版本</el-button
                ></a
              >
              <a rel="nofollow" :href="scope.row.downurl4" target="_blank"
                ><el-button
                  type="info"
                  size="small"
                  style="margin-left: 5px; margin-top: 5px"
                  >海外下载</el-button
                ></a
              >
            </div>
          </div>
          <div v-else-if="!scope.row.loading && scope.row.error">
            <p style="color: red">{{ scope.row.msg }}</p>
            <el-button
              v-if="scope.row.showButton2"
              type="danger"
              size="small"
              @click="changeV4(scope.$index)"
              style="text-align: center"
              >点击使用V4通道【价格{{ scope.row.priceV4 }}元】</el-button
            >
          </div>
          <div v-else>
            <el-button
              type="text"
              size="middle"
              @click="deleteRow(scope.$index, tableData)"
              ><i class="el-icon-close"></i
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="tableData" class="table" v-else>
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="素材ID" min-width="200">
        <template slot-scope="scope">
          <span class="id-tag">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="130">
        <template slot-scope="scope">
          <div class="price" v-if="scope.row.complete">
            <p class="font-red">余额：{{ scope.row.price }} 元</p>
          </div>
          <div class="price" v-else>
            <p
              class="font-blue"
              v-if="scope.row.type && !scope.row.isBuy && !scope.row.isChange"
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
            </p>
            <p
              class="font-blue"
              v-else-if="
                scope.row.type && !scope.row.isBuy1 && scope.row.isChange
              "
            >
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"
                ><del>(原价：{{ scope.row.orgPrice }} 元)</del></span
              >
            </p>
            <p class="font-blue" v-else>{{ scope.row.msg }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="170">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.loading"
            type="warning"
            size="small"
            effect="plain"
            >下载中</el-tag
          >
          <el-tag
            v-else-if="scope.row.complete"
            type="success"
            size="small"
            effect="plain"
            >已完成</el-tag
          >
          <el-tag
            v-else-if="scope.row.error"
            type="danger"
            size="small"
            effect="plain"
            >失败</el-tag
          >
          <el-tag
            v-else-if="scope.row.type"
            type="info"
            size="small"
            effect="plain"
            >等待处理</el-tag
          >
          <el-tag v-else type="info" size="small" effect="plain"
            >获取失败</el-tag
          >
          <div v-if="scope.row.loading" class="wait-time">
            <i class="el-icon-time"></i>
            <span>已扣费，下载中，失败自动退回</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" width="180">
        <template slot-scope="scope">
          <span class="time">{{ scope.row.submitTime || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="240">
        <template slot-scope="scope">
          <div v-if="scope.row.complete">
            <div v-if="scope.row.webType !== 'music'">
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button type="primary" size="small">点击下载</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl2"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="success" size="small">备用下载</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl3"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="danger" size="small">海外下载</el-button></a
              >
            </div>
            <div v-else>
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button type="primary" size="small">全曲版本</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl2"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="success" size="small">海外下载</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl3"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="danger" size="small">分段版本</el-button></a
              >
              <a
                rel="nofollow"
                :href="scope.row.downurl4"
                target="_blank"
                style="margin-left: 5px"
                ><el-button type="info" size="small">海外下载</el-button></a
              >
            </div>
          </div>
          <div v-else-if="scope.row.loading">
            <el-button type="text" size="small" :loading="true"
              >下载中…</el-button
            >
            <el-tag
              type="info"
              size="small"
              effect="plain"
              style="margin-left: 5px"
              >等待模式</el-tag
            >
          </div>
          <div v-else-if="scope.row.error">
            <p style="color: red">{{ scope.row.msg }}</p>
            <el-button
              v-if="scope.row.showButton2"
              type="danger"
              size="small"
              @click="changeV4(scope.$index)"
              style="text-align: center"
              >点击使用V4通道【价格{{ scope.row.priceV4 }}元】</el-button
            >
          </div>
          <div v-else>
            <el-button
              type="text"
              size="small"
              @click="deleteRow(scope.$index, tableData)"
              ><i class="el-icon-close"></i> 移除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :pager-count="11"
      layout="total, sizes, prev, pager, next"
      :total="tableData.length"
      v-if="tableData.length > 100"
    ></el-pagination>
    <div class="btn" v-if="!sureflag">
      <el-button
        type="primary"
        @click="sureDownload"
        icon="el-icon-download"
        :disabled="downflag"
        >确认下载</el-button
      >
    </div>
    <div class="btn2" v-else>
      <div v-if="tableData[0].webType !== 'music'">
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload"
            plain
            icon="el-icon-download"
            >批量下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload1"
            plain
            icon="el-icon-download"
            >批量备用下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy1($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制备用下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload2"
            plain
            icon="el-icon-download"
            >批量海外下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy2($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制海外下载链接</el-button
          >
        </div>
      </div>
      <div v-else>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload()"
            plain
            icon="el-icon-download"
            >批量全曲下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制全曲下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload1()"
            plain
            icon="el-icon-download"
            >批量全曲海外下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy1($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制全曲海外下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload2()"
            plain
            icon="el-icon-download"
            >批量分段下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy2($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制分段下载链接</el-button
          >
        </div>
        <div class="el-row">
          <el-button
            type="primary"
            @mousedown.native="batchDownload3()"
            plain
            icon="el-icon-download"
            >批量分段海外下载</el-button
          >
          <el-button
            type="primary"
            @mousedown.native="batchCopy3($event)"
            plain
            icon="el-icon-edit-outline"
            style="margin-left: 1%"
            >一键复制分段海外下载链接</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="imgPreviewVisible" center :show-close="false">
      <template #title>
        <DialogCloseBtn @close="imgPreviewVisible = false" />
        图片预览
      </template>
      <div
        style="
          width: 100%;
          text-align: center;
          max-height: 450px;
          overflow: auto;
        "
      >
        <el-image :src="currentImg">
          <div slot="error" class="image-slot">
            <img
              :src="currentError"
              style="object-fit: fill; width: 100%; height: 107.5%"
              alt
            />
          </div>
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hasBlance } from "../../../api/downLoad";
import { buyWait, check } from "../../../api/downLoad";
import { getSessionUser } from "../../../api/auth";
import { message } from "@/utils/resetMessage";
import { MessageBox } from "element-ui";
import Clipboard from "clipboard";
import DialogCloseBtn from "@/components/DialogCloseBtn.vue";
import { getV3Status, getV4Status } from "../../../utils/storage";
export const downloadFile = (url) => {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none"; // 防止影响页面
  iframe.style.height = 0; // 防止影响页面
  iframe.src = url;
  document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
  // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
  setTimeout(() => {
    iframe.remove();
  }, 1000);
};

export default {
  components: {
    DialogCloseBtn,
  },
  props: ["data", "sureflag", "downflag", "clearflag", "netError"],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      downloadStarted: false,
      urlArray: [], //批量下载
      urlArray1: [], //批量备用下载
      urlArray2: [], //批量海外下载
      urlArray3: [], //批量海外下载  分段海外下载
      currentIndex: 0, //当前列表序号
      errorTimes: 0, //查询错误次数
      rightTimes: 0, //查询正确次数
      timer1: null, //定时器
      isAutoDowload: false, //是否自动下载
      imgPreviewVisible: false,
      currentError: "",
      currentImg: "",
    };
  },
  watch: {
    clearflag: {
      handler(val) {
        if (val) {
          this.currentIndex = 0;
          this.downloadStarted = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    tableData() {
      return this.data;
    },
    anyLoading() {
      return this.tableData.some((r) => r.loading);
    },
  },
  mounted() {
    //自动锚点
    this.$EventBus.$on("move", (data) => {
      if (data == "1") {
        this.goAnchor("position");
      }
    });
    //是否自動下載
    this.$EventBus.$on("auto", (data) => {
      if (data == "1") {
        this.sureDownload();
      }
    });
    this.$EventBus.$on("nextId", (data) => {
      //将A组件传递过来的参数data赋值给msgB
      if (data >= 0) {
        //window.clearInterval();
        this.$emit("clearTimer");
        this.errorTimes = 0;
        this.rightTimes = 0;
        this.currentIndex = data + 1;
        //更新余额
        getSessionUser({})
          .then((result) => {
            this.$store.dispatch("setUserInfo", result);
          })
          .catch((error) => {});
        if (this.currentIndex < this.tableData.length) {
          let item = this.tableData[this.currentIndex];
          if (!item.checking) {
            item.checking = true;
            //未下载完成的进行下载
            this.downloadOne(this.currentIndex);
          } else {
            let checkdata = {
              imageID: item.id,
              webType: item.webType,
            };
            this.checkStatus(checkdata, this.currentIndex);
          }
        } else {
          this.$emit("onSureDown", true);
          this.$emit("onDownload", false);
        }
      }
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("move");
    this.$EventBus.$off("auto");
    this.$EventBus.$off("nextId");
    this.$emit("clearTimer");
  },
  methods: {
    popSuccess() {
      if (document.getElementsByClassName("el-message").length > 0) return;
      this.$message({
        message: "下载成功",
        type: "success",
        showClose: true,
        duration: 4000,
        offset: 80,
      });
    },
    goAnchor(e) {
      var id = "#" + e;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    },
    //普通下载
    ordinaryDownload(index, row) {
      //window.open(row.downurl,"_self");
      downloadFile(row.downurl);
    },
    //备用下载
    standbyDownload(index, row) {
      //window.open(row.downurl2,"_self");
      downloadFile(row.downurl2);
    },
    //迅雷下载
    thunderDownload(index, row) {
      console.log("thunderDownload: " + row.downurl);
      //this.thunderHref=row.downurl;
      console.log("thunderDownload: " + index);
    },
    changeV4(index) {
      //this.$emit("chanegV4", 2);
      //this.$emit("serverDialog");
      this.downloadOneV4(index);
    },
    stampSubmitTime() {
      const now = this.nowStr();
      this.tableData.forEach((item) => {
        if (item.type && !item.submitTime) {
          this.$set(item, "submitTime", now);
        }
      });
    },
    nowStr() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        p(d.getMonth() + 1) +
        "-" +
        p(d.getDate()) +
        " " +
        p(d.getHours()) +
        ":" +
        p(d.getMinutes()) +
        ":" +
        p(d.getSeconds())
      );
    },
    //确认下载
    sureDownload() {
      this.urlArray = [];
      this.urlArray1 = [];
      this.urlArray2 = [];
      var counts = 0;
      var offsetCounts = 0;
      this.currentIndex = 0;
      this.tableData.forEach((item) => {
        if (item.type) {
          counts++;
          if (item.isOffset) {
            offsetCounts++;
          }
        }
      });
      this.stampSubmitTime();
      if (counts > 0) {
        this.downloadStarted = true;
        if (offsetCounts > 0) {
          MessageBox.confirm(
            "您此次下载含ss高级图，高级图费用较特殊，请您确认是否下载？",
            "温馨提示",
            {
              confirmButtonText: "继续下载",
              cancelButtonText: "取消下载",
              type: "warning",
            }
          )
            .then(() => {
              this.$emit("onSureDown", false);
              this.$emit("onDownload", true);
              //判断是否够余额
              this.downloadOne(this.currentIndex);
            })
            .catch(() => {
              this.downloadStarted = false;
            });
        } else {
          this.$emit("onSureDown", false);
          this.$emit("onDownload", true);
          //判断是否够余额
          this.downloadOne(this.currentIndex);
        }
      } else {
        message.success({
          message: "请先输入需要下载的ID",
          duration: 4000,
          offset: 80,
        });
      }
    },
    //下载方法
    downloadOne(index) {
      let item = this.tableData[index];
      if (item.type) {
        //正常才搜索
        item.loading = true;
        let dataform = {
          imageIDs: item.id,
          webType: item.webType,
        };
        hasBlance(dataform)
          .then((result) => {
            if (result) {
              //如果余额足够，则开始获取下载链接
              let buydata = {
                imageID: item.id,
                webType: item.webType,
                format: item.value,
                isCos: item.isCos,
              };
              buyWait(buydata)
                .then((result) => {
                  let checkdata = {
                    imageID: item.id,
                    webType: item.webType,
                  };
                  this.checkStatus(checkdata, index);
                })
                .catch(() => {
                  buyWait(buydata)
                    .then((result) => {
                      let checkdata = {
                        imageID: item.id,
                        webType: item.webType,
                      };
                      this.checkStatus(checkdata, index);
                    })
                    .catch(() => {
                      item.loading = false;
                      item.msg = "该ID下载失败，请联系管理员";
                      item.error = true;
                      this.$EventBus.$emit("nextId", index); //下一个ID
                    });
                });
            } else {
              message.error({
                message: "您的余额已不足，请充值",
                duration: 3000,
                offset: 100,
              });
              item.loading = false;
              item.msg = "下载失败，余额不足";
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
            }
          })
          .catch((error) => {
            if (error.message.indexOf("账号余额不足") > -1) {
              item.msg = "下载失败，余额不足";
              item.loading = false;
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
            } else {
              item.msg = "下载失败，网络异常";
              item.loading = false;
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
              this.$EventBus.$emit("nextId", index); //下一个ID
            }
          });
      } else {
        //如果判断
        this.$EventBus.$emit("nextId", index); //下一个ID
      }
    },
    //下载方法V4
    downloadOneV4(index) {
      let item = this.tableData[index];
      if (item.type) {
        //正常才搜索
        item.loading = true;
        let dataform = {
          imageIDs: item.id,
          webType: "shutterstock_V4",
        };
        hasBlance(dataform)
          .then((result) => {
            if (result) {
              //如果余额足够，则开始获取下载链接
              let buydata = {
                imageID: item.id,
                webType: "shutterstock_V4",
                format: item.value,
                isCos: item.isCos,
              };
              buyWait(buydata)
                .then((result) => {
                  let checkdata = {
                    imageID: item.id,
                    webType: "shutterstock_V4",
                  };
                  this.checkStatus(checkdata, index);
                })
                .catch(() => {
                  buyWait(buydata)
                    .then((result) => {
                      let checkdata = {
                        imageID: item.id,
                        webType: "shutterstock_V4",
                      };
                      this.checkStatus(checkdata, index);
                    })
                    .catch(() => {
                      item.loading = false;
                      item.msg = "该ID下载失败，请联系管理员";
                      item.error = true;
                      this.$EventBus.$emit("nextId", index); //下一个ID
                    });
                });
            } else {
              message.error({
                message: "您的余额已不足，请充值",
                duration: 3000,
                offset: 100,
              });
              item.loading = false;
              item.msg = "下载失败，余额不足";
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
            }
          })
          .catch((error) => {
            if (error.message.indexOf("账号余额不足") > -1) {
              item.msg = "下载失败，余额不足";
              item.loading = false;
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
            } else {
              item.msg = "下载失败，网络异常";
              item.loading = false;
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
              this.$EventBus.$emit("nextId", index); //下一个ID
            }
          });
      } else {
        //如果判断
        this.$EventBus.$emit("nextId", index); //下一个ID
      }
    },
    checkStatus(checkdata, index) {
      const checkTimer = setInterval(() => {
        check(checkdata)
          .then((res) => {
            let item = this.tableData[index];
            if (res.status == 0) {
              //完成下载
              item.videoDisabled = true;
              item.disabled = true;
              item.complete = true;
              item.loading = false;
              item.downurl = res.downloadUrl
                .replace("httpss", "https")
                .replace("down.songzituku.com", "pp.sucaidaixia.com");
              item.downurl2 = res.downloadUrl2
                .replace("httpss", "https")
                .replace("down.songzituku.com", "pp.sucaidaixia.com");
              item.downurl3 = res.downloadUrl3.replace("httpss", "https");
              item.price = res.price;
              this.urlArray.push(item.downurl); //批量
              this.urlArray1.push(item.downurl2); //批量备用
              this.urlArray2.push(item.downurl3); //批量备用
              if (item.webType == "music") {
                item.downurl4 = res.downloadUrl4;
                this.urlArray3.push(item.downurl4); //批量备用
              }
              this.$EventBus.$emit("nextId", index); //下一个ID
            } else if (res.status == 1) {
              //继续查询--不能一直查
              this.rightTimes = this.rightTimes + 1;
              if (this.rightTimes >= 50) {
                let item = this.tableData[index];
                item.complete = false;
                item.loading = false;
                item.error = true;
                if (
                  (item.webType === "shutterstock" ||
                    item.webType === "shutterstock_V2" ||
                    item.webType === "shutterstock_V3") &&
                  getV4Status() === "online"
                ) {
                  //item.msg = "资源下载失败，请更换其他编号下载。\n 实在需要此编号，可以联系客服下载，成本比较高，价格贵，提供给急用的客户使用。";
                  item.msg = "渠道下载失败，可以点击下方按钮使用V4渠道进行下载";
                  item.showButton = false;
                  item.showButton2 = true;
                } else {
                  item.msg = "下载失败，请重新尝试";
                  item.showButton = false;
                  item.showButton2 = false;
                }
                this.$EventBus.$emit("nextId", index); //下一个ID
              }
            } else {
              item.complete = false;
              item.loading = false;
              item.error = true;
              if (
                (item.webType === "shutterstock" ||
                  item.webType === "shutterstock_V2" ||
                  item.webType === "shutterstock_V3") &&
                getV4Status() === "online"
              ) {
                //item.msg = "资源下载失败，请更换其他编号下载。\n 实在需要此编号，可以联系客服下载，成本比较高，价格贵，提供给急用的客户使用。";
                //item.msg = "资源下载失败，请更换其他编号下载。\n 实在需要此编号，可以联系客服下载，成本比较高，价格贵，提供给急用的客户使用。";
                item.msg = "渠道下载失败，可以点击下方按钮使用V4渠道进行下载";
                item.showButton = false;
                item.showButton2 = true;
              } else {
                item.msg = "下载失败，请重新尝试";
                item.showButton = false;
                item.showButton2 = false;
              }
              this.$EventBus.$emit("nextId", index); //下一个ID
            }
          })
          .catch((err) => {
            let item = this.tableData[index];
            if (err.message.indexOf("账户余额") > -1) {
              item.msg = "下载失败，余额不足";
              item.loading = false;
              item.error = true;
              this.$emit("onSureDown", true);
              this.$emit("onDownload", false);
              this.$emit("clearTimer");
            } else {
              this.errorTimes = this.errorTimes + 1;
              if (this.errorTimes >= 5) {
                let item = this.tableData[index];
                item.complete = false;
                item.loading = false;
                item.error = true;
                if (
                  (item.webType === "shutterstock" ||
                    item.webType === "shutterstock_V2" ||
                    item.webType === "shutterstock_V3") &&
                  getV4Status() === "online"
                ) {
                  //item.msg = "资源下载失败，请更换其他编号下载。\n 实在需要此编号，可以联系客服下载，成本比较高，价格贵，提供给急用的客户使用。";
                  //item.msg = "资源下载失败，请更换其他编号下载。\n 实在需要此编号，可以联系客服下载，成本比较高，价格贵，提供给急用的客户使用。";
                  item.msg = "渠道下载失败，可以点击下方按钮使用V4渠道进行下载";
                  item.showButton = false;
                  item.showButton2 = true;
                } else {
                  item.msg = "下载失败，请重新尝试";
                  item.showButton = false;
                  item.showButton2 = false;
                }
                this.$EventBus.$emit("nextId", index); //下一个ID
              }
            }
          });
      }, 4000);

      this.$once("hook:beforeDestroy", () => {
        clearInterval(checkTimer);
      });
      this.$once("clearTimer", () => {
        clearInterval(checkTimer);
      });
    },
    //全部下载
    allDownload() {
      this.popSuccess();
    },
    //批量下载
    batchDownload() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray.length; i++) {
        if (newArr.indexOf(this.urlArray[i]) === -1) {
          newArr.push(this.urlArray[i]);
        }
      }
      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },

    //批量下载
    batchDownload1() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray1.length; i++) {
        if (newArr.indexOf(this.urlArray1[i]) === -1) {
          newArr.push(this.urlArray1[i]);
        }
      }

      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },
    //批量下载
    batchDownload2() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray2.length; i++) {
        if (newArr.indexOf(this.urlArray2[i]) === -1) {
          newArr.push(this.urlArray2[i]);
        }
      }
      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },

    //批量下载
    batchDownload3() {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray3.length; i++) {
        if (newArr.indexOf(this.urlArray3[i]) === -1) {
          newArr.push(this.urlArray3[i]);
        }
      }
      for (var g = 0; g < newArr.length; g++) {
        const url = newArr[g];
        window.open(url, "_blank");
      }
    },
    batchCopy(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray.length; i++) {
        if (newArr.indexOf(this.urlArray[i]) === -1) {
          newArr.push(this.urlArray[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy1(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray1.length; i++) {
        if (newArr.indexOf(this.urlArray1[i]) === -1) {
          newArr.push(this.urlArray1[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy2(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray2.length; i++) {
        if (newArr.indexOf(this.urlArray2[i]) === -1) {
          newArr.push(this.urlArray2[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy3(e) {
      //去重复
      let newArr = [];
      for (let i = 0; i < this.urlArray3.length; i++) {
        if (newArr.indexOf(this.urlArray3[i]) === -1) {
          newArr.push(this.urlArray3[i]);
        }
      }
      var text = "";
      for (var g = 0; g < newArr.length; g++) {
        text += newArr[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    deleteRow(index, row) {
      row.splice(index, 1);
    },
    changePrice(index, row, label, val) {
      row[index].videoLabel = label;
      row[index].videoValue = val;
      console.log(row[index].webType);
      if (row[index].webType.indexOf("vistockphoto") != -1) {
        switch (val) {
          case 0:
            row[index].webType = "vistockphoto";
            break;
          case 1:
            row[index].webType = "vistockphotofk";
            break;
        }
      } else {
        switch (val) {
          case 0:
            row[index].isChange = false;
            row[index].webType = "video";
            if (row[index].isBuy) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
          case 1:
            row[index].isChange = true;
            row[index].webType = "videofk";
            if (row[index].isBuy1) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
          case 2:
            row[index].isChange = false;
            row[index].webType = "videoyx";
            if (row[index].isBuy) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
          case 3:
            row[index].isChange = true;
            row[index].webType = "videoyxfk";
            if (row[index].isBuy1) {
              row[index].msg = "免费";
            } else {
              row[index].msg = "";
            }
            break;
        }
      }
      row[index].price = row[index].priceList[val].price;
    },
    changeV3() {
      this.$emit("chanegV3", 1);
    },
    handleImgPreview(row) {
      this.imgPreviewVisible = true;
      if (row.webType.indexOf("shutterstock") > -1) {
        this.currentImg =
          "https://img.aatuku.com/preview260/" + row.id + ".jpg";
        this.currentError = row.errorIcon;
      } else {
        this.currentImg = row.img;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* 两态状态表 + 等待模式感知 样式 */
.table {
  ::v-deep .el-table__header-wrapper th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
  }
}
.id-tag {
  display: inline-block;
  padding: 2px 10px;
  background: #f0f7ff;
  color: #0773fc;
  border-radius: 4px;
  font-size: 13px;
  font-family: monospace;
}
.wait-time {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
  i {
    margin-right: 3px;
  }
}
.time {
  font-size: 13px;
  color: #666;
}
::v-deep .wait-alert .el-alert__title,
::v-deep .wait-alert .el-alert__description {
  color: #f56c6c;
}
//进度条
.processBar {
  width: 240px;
  height: 7px;
  border: 1px solid #0059ca;
  border-radius: 2px;
  animation: progress-bar-stripes 2s linear infinite;
  background-color: #ea4335;
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  opacity: 1;
}
@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

.content {
  text-align: center;
}

.table {
  .el-table__body {
    img {
      margin-right: 10px;
      float: left;
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }
    .fr {
      .code {
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        color: #578ade;
        .label {
          font-size: 16px;
          color: #43424b;
        }
      }
      .size {
        padding-left: 10px;
        font-size: 10px !important;
      }
    }
    .el-button--mini.is-round {
      padding: 4px 10px;
      span {
        font-size: 10px;
      }
    }
    .price {
      .font-blue {
        color: #ea4335;
      }
      .font-red {
        color: #f56c6c;
      }
      .font-green {
        color: #67c23a;
      }
    }
  }
}
.btn {
  margin: 20px 0 100px;
  .el-button {
    margin-bottom: 20px;
    margin-left: 0;
    padding: 15px 20px;
    width: 100%;
    font-size: 16px;
    // color: #EA4335;
    // background: #fff;
    border-color: #ea4335;
    outline: none;
    i {
      font-size: 16px;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #ea4335;
    border-color: #ea4335;
    color: #ffffff;
  }
  .el-button--success.is-plain:hover {
    background: #00cc66;
    border-color: #00cc66;
    color: #ffffff;
  }
  .el-button--info.is-plain:hover {
    background: #ff9900;
    border-color: #ff9900;
    color: #ffffff;
  }
  .el-button--danger.is-plain:hover {
    background: #ff3300;
    border-color: #ff3300;
    color: #ffffff;
  }
}

.btn2 {
  margin: 20px 0 100px;
  .el-button {
    margin-bottom: 20px;
    margin-left: 0;
    padding: 15px 20px;
    width: 49.5%;
    font-size: 16px;
    color: #ea4335;
    background: #fff;
    border-color: #ea4335;
    outline: none;
    i {
      font-size: 16px;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #ea4335;
    border-color: #ea4335;
    color: #ffffff;
  }
  .el-button--success.is-plain:hover {
    background: #00cc66;
    border-color: #00cc66;
    color: #ffffff;
  }
  .el-button--info.is-plain:hover {
    background: #ff9900;
    border-color: #ff9900;
    color: #ffffff;
  }
  .el-button--danger.is-plain:hover {
    background: #ff3300;
    border-color: #ff3300;
    color: #ffffff;
  }
}

.el-pagination {
  margin: 20px 0 30px;
}
.this-page {
  padding: 30px;
  background-color: white;
}
</style>
